import { useEffect, useRef, useState } from "react";
import { createTripGeolocationSession } from "./tripGeolocation.js";
const initialState = {
  permission: "unknown",
  status: "idle",
  location: null,
  error: null
};
export default function useTripGeolocation({
  enabled
}) {
  const [state, setState] = useState(initialState);
  const sessionRef = useRef(null);
  if (sessionRef.current === null && typeof navigator !== "undefined") {
    sessionRef.current = createTripGeolocationSession({
      geolocation: navigator.geolocation,
      onStateChange: setState
    });
  }
  useEffect(() => {
    const session = sessionRef.current;
    if (!session) {
      setState({
        permission: "unsupported",
        status: "error",
        location: null,
        error: {
          code: 0,
          message: "Geolocation is not supported."
        }
      });
      return undefined;
    }
    let active = true;
    let permissionStatus = null;
    const handlePermissionChange = () => {
      if (active) session.setPermission(permissionStatus?.state);
    };
    if (navigator.permissions?.query) {
      void navigator.permissions.query({
        name: "geolocation"
      }).then(nextPermissionStatus => {
        if (!active) return;
        permissionStatus = nextPermissionStatus;
        session.setPermission(permissionStatus.state);
        permissionStatus.addEventListener?.("change", handlePermissionChange);
      }).catch(() => {
        // watchPosition remains the source of truth when Permissions is absent.
      });
    }
    return () => {
      active = false;
      permissionStatus?.removeEventListener?.("change", handlePermissionChange);
      session.destroy();
    };
  }, []);
  useEffect(() => {
    const session_0 = sessionRef.current;
    if (!session_0) return undefined;
    let active_0 = true;
    if (enabled) {
      void Promise.resolve().then(() => {
        if (active_0) session_0.start();
      });
    } else {
      session_0.stop();
    }
    return () => {
      active_0 = false;
      session_0.stop();
    };
  }, [enabled]);
  return state;
}